<div class="main-wrapper" [ngClass]="{expand}" appClickOutside (clickOutside)="expand = false">
  <div class="link-box-wrapper display-flex" (click)="$event.stopPropagation()">
    <div class="link-title">
      <span>Logged in</span>
    </div>
    <div class="link-list">
      <div class="first-link display-flex justify-content-space-between align-items-center" (click)="expand = !expand">
        <span>Ctrl</span>
        <span class="icon-chevron cursor-pointer" [ngClass]="{'expand-icon': expand, 'collapse-icon': expand === false}">
          <fa-icon icon="chevron-down"></fa-icon>
        </span>
      </div>
      <div *ngIf="expand" nz-tooltip="Open Link in New Tab" nzTooltipPlacement="bottom" class="second-link display-flex align-items-center" (click)="openSpearAdInNewTab()">
        <span>Spearad</span>
      </div>
    </div>
  </div>
</div>
